/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
// import CustomAlert from 'components/alerts/CustomAlert';
import Backdrop from 'components/base/Backdrop';
import Button from 'components/base/Button';
import { useAlert } from 'providers/AlertModalProvider';
import UpiIcon from 'assets/img/icon/UPI-Color.png';
import UpiIconDark from 'assets/img/icon/UPI-Color-dark.png';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import fetchData from 'services/fetchData';
import { formatDate } from 'services/utils';
import Badge from 'components/base/Badge';
import { getPaymentStatus } from 'helpers/status-badge';
import StatusBadge from 'components/custom/ui/StatusBadge';
import apiEndpoints from 'constants/apiEndpoints';
import PageLoader from 'components/custom/animate-component/PageLoader';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    /* max-width: 300px !important; */
    margin-right: auto;

    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const CoalIronOreChallanDetailModal = ({ show, handleClose, challan_no }) => {
  const [loading, setLoading] = useState(true);
  const [challanDetail, setChallanDetail] = useState({});
  console.log(
    '🚀 ~ CoalIronOreChallanDetailModal ~ challanDetail:',
    challanDetail
  );

  const trans_status =
    challanDetail?.challan_print_detail?.payment_transactions?.at(
      -1
    )?.trans_status;
  console.log(
    '🚀 ~ CoalIronOreChallanDetailModal ~ trans_status:',
    trans_status
  );
  const trans_type =
    challanDetail?.challan_print_detail?.payment_transactions?.at(
      -1
    )?.trans_type;
  console.log(
    '🚀 ~ CoalIronOreChallanDetailModaltrans_type ~ trans_status:',
    trans_type
  );

  const {
    challan_date,
    gate_pass_no,
    gate_pass_date,
    driver_upi_id,
    consignee_name,
    consigner_name,
    do_number,
    driver_mobile,
    driver_name,
    from_city_name,
    gross_weight,
    material_name,
    net_weight,
    po_number,
    tare_weight,
    to_city_name,
    vehicle_number,
    location_name,
    destination_name
  } = challanDetail.challan_print_detail || {};

  const { showAlert } = useAlert();

  useEffect(() => {
    setLoading(true);
    const fetchRequest = async () => {
      const response = await fetchData(
        apiEndpoints.challan.getChallanPrint(challan_no)
      );
      if (response.status) {
        setChallanDetail(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        handleClose();
        showAlert({
          variant: 'danger',
          message: `Failed to fetch challan ${challan_no} detail: ${response.message}`
        });
      }
    };
    fetchRequest();
  }, []);

  return (
    <>
      <CustomModal
        //   size="md"
        //   dialogClassName="modal-300px"
        show={show}
        onHide={handleClose}
        backdrop="static"
        // style={{ overflow: 'hidden' }}
        keyboard={false}
        centered
      >
        <Modal.Header
          className="border-0 position-relative pb-0 end-0 dark__text-white"
          closeButton={!loading}
        >
          <div>
            <div className="d-flex align-items-center ">
              Detail of challan {challan_no}
            </div>
            <p className="mb-2 text-900 fs-9">
              Created on {formatDate(challan_date, 'DD MMM YYYY')} /{' '}
              {formatDate(challan_date, 'hh:mm a')}
            </p>
          </div>
        </Modal.Header>

        <Modal.Body className="pt-2 position-relative">
          <div className="border border-1 p-2 rounded-2 mb-2 card">
            <Row className="mb-2">
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField challanData={driver_name} label="Driver Name" />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  challanData={driver_mobile}
                  label="Driver Mobile"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  challanData={vehicle_number}
                  label="Vehicle No."
                />
              </Col>
            </Row>
          </div>
          <div className="border border-1 p-2 rounded-2 mb-2 card">
            <Row className="mb-2 flex-lg-wrap">
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField challanData={driver_upi_id} label="UPI ID" />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  challanData={
                    <>
                      {trans_type === 'Upi' ? (
                        <>
                          <img
                            className="d-dark-none"
                            src={UpiIcon}
                            width={'40px'}
                            height={'20px'}
                            alt="upi icon"
                          />
                          <img
                            className="d-light-none"
                            src={UpiIconDark}
                            width={'40px'}
                            height={'20px'}
                            alt="upi icon"
                          />
                        </>
                      ) : (
                        <Badge
                          bg={'primary'}
                          variant="pill"
                          iconPosition="end"
                          className="fs-9 font-outfit"
                        >
                          {/* {challanDetail['trans_type']} */}
                          {/* Not Proceed */}
                          {trans_type ? trans_type : 'Not Proceed'}
                        </Badge>
                      )}
                    </>
                  }
                  label="Payment Mode"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  challanData={
                    <StatusBadge
                      badgeDetail={getPaymentStatus(
                        // challanDetail['trans_status']
                        // 'Not Proceed'
                        trans_status
                      )}
                      // status={challanDetail['trans_status']}
                      status="Not Proceed"
                    />
                  }
                  label="Transaction Status"
                />
              </Col>
            </Row>
          </div>
          <div className="border border-1 p-2 rounded-2 mb-2 card">
            <Row className="mb-2">
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={location_name}
                  label="From City"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={destination_name}
                  label="To City"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={consignee_name}
                  label="Consignee"
                />
              </Col>

              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={consigner_name}
                  label="Consigner"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={gate_pass_no}
                  label="Get Pass No. "
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  // challanData={gate_pass_date?.split(' ')?.[0]}
                  challanData={`${gate_pass_date ? formatDate(gate_pass_date, 'DD MMM YYYY', false) : '--'}`}
                  label="Get Pass Date "
                />
              </Col>
            </Row>
          </div>
          <div className="border border-1 p-2 rounded-2 card">
            <Row className="mb-2">
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={gross_weight}
                  label="Gross Weight"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={tare_weight}
                  label="Tare Weight"
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={net_weight}
                  label="Net Weight"
                />
              </Col>

              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={po_number}
                  label="P. O. No."
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={do_number}
                  label="D.O. No."
                />
              </Col>
              <Col className="mt-2" sm={4} xs={6}>
                <ChallanField
                  className={'w-100'}
                  challanData={material_name}
                  label="Material"
                />
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="phoenix-secondary"
            disabled={loading}
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
        <PageLoader loading={loading} loadingMessage={'Fetching challan'} />
      </CustomModal>
    </>
  );
};

const ChallanField = ({ challanData, label, className }) => {
  return (
    <div className={className}>
      <div className="d-flex align-items-center">
        <p className="mb-0 fs-9  text-600">{label || '[Label]'}</p>
        {/* <h6 className=" text-700 mb-0">{challanData?.label}</h6> */}
      </div>
      <div className="d-flex justify-content-between gap-2">
        <div
          className={`d-flex  w-100 ${challanData ? 'text-1100' : 'text-400'}`}
        >
          {challanData || 'No Data'}
        </div>
      </div>
      {/* <p className="lh-sm mb-0 text-1100">{challanData?.value}</p> */}
    </div>
  );
};

export default CoalIronOreChallanDetailModal;
